import { PqrHistorical } from '../../../../../shared/types/modules/pqr';

export interface PqrHistoricalProps {
    historical: PqrHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    IdPQR: 'ID PQR',
    IdPqrSfc: 'ID PQR SFC',
    status: 'Estado',
    callId: 'Call ID',
    location: 'Ubicación PQR',
    createAt: 'Fecha de creación',
    userCreate: 'Creado por',
    address: 'Detalle PQR',
    branch: 'Sucursal de expedición',
    receptionChannel: 'Canal de recepción',
    type: 'Tipo PQR',
    half: 'Medio',
    subtypeDp: 'Subtipo DP',
    procedure: 'Trámite',
    product: 'Producto',
    motive: 'Motivo',
    submotive1: 'Submotivo 1',
    submotive2: 'Submotivo 2',
    submotive3: 'Submotivo 3',
    submotive4: 'Submotivo 4',
    email: 'E-mail notificación',
    phone: 'Teléfono notificación',
    channelPresentsFailure: 'Canal qué presentó falla',
    isGuardianship: '¿Es tutela?',
    guardianship: 'Número de tutela',
    controlEntity: 'Ente de control',
    dcfScaling: 'Escalamiento DCF',
    hasReconsideration: '¿Es una reconsideración?',
    desistd: 'Desistimiento',
    hasExpressComplaint: '¿Es una queja express?',
    receptionInstance: 'Instancia de recepción',
    receptionPoint: 'Punto de recepción',
    admission: 'Admisión',
    isVirtualProduct: '¿Es producto virtual?',
    acceptance: 'Aceptación',
    rectification: 'Rectificación',
    isExtension: '¿Es prorroga?',
    finalResponseAttached: 'Anexos a la respuesta final',
    marking: 'Marcación',
    fraudType: 'Tipología de fraude',
    fraudMode: 'Modalidad de fraude',
    claimedAmount: 'Monto reclamado',
    approvedAmount: 'Monto reconocido',
    closingDateDCF: 'Fecha cierre DCF',
    customerFilingDate: 'Fecha y hora radicación cliente',
    updateStatusPQRDate: 'Fecha actualización estado PQR',
    answerSFCDate: 'Fecha respuesta SFC',
    gender: 'Genero',
    isLGBTIQ: '¿Se identifica como LGBTIQ?',
    replica: 'Replica',
    pqrReplica: 'Código queja relacionado',
    observationsReplica: 'Argumento de la replica',
    country: 'País',
    correspondenceFiling: 'Radicado de correspondencia',
    detail: 'Detalle de PQR',
    policy: 'Póliza',
    bonusValue: 'Valor de la prima',
    plate: 'Placa',
    strategicAlly: 'Aliado estratégico',
    notificationProcedureDate: 'Fecha de notificación trámite',
    createdAt: 'Fecha de registro sistema',
    processingDate: 'Fecha trámite',
    suspensionDate: 'Fecha de suspensión',
    sendEmailExpansionInformation:
        'Enviar email - Ampliación de la información',
    reactivationDate: 'Fecha de reactivación',
    extensionDate: 'Fecha de prórroga',
    sendEmailExtension: 'Enviar email - Prórroga',
    alertSFCDate: 'Fecha alerta SFC',
    responseDate: 'Fecha de respuesta',
    sendEmailResponse: 'Enviar email - Respuesta',
    notificationResponseDate: 'Fecha de notif, respuesta',
    sacDate: 'Fecha de SAC',
    furagDate: 'Fecha Normativa',
    closingDate: 'Fecha de cierre',
    area1: 'Área encargada',
    person1: 'Persona encargada',
    email1: 'Email',
    area2: 'Área encargada',
    person2: 'Persona encargada',
    email2: 'Email',
    area3: 'Área encargada',
    person3: 'Persona encargada',
    email3: 'Email',
    redirectPqr: '¿Redireccionar PQR?',
    generateAlert: '¿Generar alerta?',
    inFavorOf: 'A favor de',
    causality: 'Causalidad',
    protection: 'Amparo',
    responseMedium: 'Medio de respuesta',
    observation: 'Observación medio de respuesta',
    auditObservations: 'Observaciones de auditoría',
    complianceTerms: 'Cumplimiento de términos',
    nonComplianceReason: 'Motivo incumplimiento',
    manualSendToSfcIfAudit: '¿Enviar a la SFC?',
};
